import React, { useEffect, useState } from 'react'
import { Loader } from '../Loader/Loader'
import { Avatar, Badge, Input, Empty, List } from 'antd'
import { MenuUnfoldOutlined, ArrowLeftOutlined, PaperClipOutlined, SmileOutlined } from '@ant-design/icons';
import avar from '../Assets/avar.png'

const Support = ({ loader, setCollapsed }) => {
    const [chat, setChat] = useState(false);
    const [chatMessages, setChatMessages] = useState([]); // <-- store messages in state
    const [noData, setNodata] = useState(false);

    const defaultMessages = [
        {
            id: 1,
            sender: "support",
            text: "Hello! 👋 How can I help you today?",
            avatar: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
        },
        {
            id: 2,
            sender: "user",
            text: "I want to know the status of my order.",
            avatar: "https://cdn-icons-png.flaticon.com/512/1077/1077012.png",
        },
        {
            id: 3,
            sender: "support",
            text: "Sure, let me check that for you...",
            avatar: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
        },

        {
            id: 1,
            sender: "support",
            text: "Hello! 👋 How can I help you today?",
            avatar: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
        },
        {
            id: 2,
            sender: "user",
            text: "I want to know the status of my order.",
            avatar: "https://cdn-icons-png.flaticon.com/512/1077/1077012.png",
        },
        {
            id: 3,
            sender: "support",
            text: "Sure, let me check that for you...",
            avatar: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
        },
        {
            id: 1,
            sender: "support",
            text: "Hello! 👋 How can I help you today?",
            avatar: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
        },
        {
            id: 2,
            sender: "user",
            text: "I want to know the status of my order.",
            avatar: "https://cdn-icons-png.flaticon.com/512/1077/1077012.png",
        },
        {
            id: 3,
            sender: "support",
            text: "Sure, let me check that for you...",
            avatar: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
        },


    ];

    const openChat = () => {
        setChat(true);
        setChatMessages(defaultMessages); // load fresh messages when entering chat
    };

    const closeChat = () => {
        setChat(false);
        setChatMessages([]); // clear messages when going back
    };

    return (
        <>
            {loader ? (
                <Loader />
            ) : chat ? (
                <>
                    {/* Chat Header */}
                    <div className="display-5 p-20 trad-pos">
                        <div className="display-1 gap-15">
                            <ArrowLeftOutlined
                                className="cursor"
                                style={{ fontSize: "20px", color: "#fff" }}
                                onClick={closeChat}
                                id='cs'
                            />
                            <div className="side-title">
                                Support
                                <div className="display-1 chat-desc v2">
                                    <div className="dot" />
                                    Online
                                </div>
                            </div>
                        </div>
                        <div className='cursor' onClick={() => setCollapsed(true)} id='cs'>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z" fill="#82858E" stroke="#82858E" stroke-width="1.5294" />
                            </svg>
                        </div>
                    </div>

                    {/* Chat Body */}
                    <div className="chat-body">
                        {noData ? (
                            <Empty
                                description="No Chat Found"
                                style={{ color: "#fff" }}
                                className="empty"
                            />
                        ) : (
                            chatMessages.map((msg) => (
                                <div className={`chat-message ${msg.sender}`}>
                                    {msg.sender === "support" && (
                                        <Avatar src={msg.avatar} className="chat-avatar" />
                                    )}
                                    <div className="chat-bubble">{msg.text}</div>
                                    {msg.sender === "user" && (
                                        <Avatar src={msg.avatar} className="chat-avatar" />
                                    )}
                                </div>
                            ))
                        )}
                    </div>

                    {/* Chat Input */}
                    <div className="chat-input-container">
                        <Input placeholder="Type a message" className="chat-input" bordered={false} />
                        <SmileOutlined className="chat-icon" />
                        <PaperClipOutlined className="chat-icon" />
                    </div>
                </>
            ) : (
                <>
                    {/* Support List */}
                    <div className="display-5 p-20">
                        <div className="side-title">Chats & Support</div>
                        <div className='cursor' onClick={() => setCollapsed(true)} id='cs'>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z" fill="#82858E" stroke="#82858E" stroke-width="1.5294" />
                            </svg>
                        </div>
                    </div>
                    <div
                        id='cs'

                        className="display-1  p-20 cursor hov-sup"
                        onClick={openChat}
                    >
                        <Badge
                            dot
                            offset={[-3, 35]}
                            style={{ width: "8px", height: "8px" }}
                            color={"#009A2D"}
                        >
                            <Avatar icon={<MenuUnfoldOutlined />} size={44} />
                        </Badge>
                        <div className="chat-txt">
                            Support
                            <div className="chat-desc">Every day, around the clock</div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Support